var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"line-state icon iconfont icon-on-line",class:_vm.styleClass})}
var staticRenderFns = []

export { render, staticRenderFns }